/** UI permissions only; help_errors RLS remains the authority for data access. */
export function getHelpAccess(plan: string | null, hasActiveSubscription: boolean, isSuperAdmin: boolean) {
  return {
    canView: isSuperAdmin || (plan === "enterprise" && hasActiveSubscription),
    canManage: isSuperAdmin,
  };
}